import React from 'react'
import * as Bs from 'react-bootstrap'

/**
 * Tooltip that shows above wrapped content
 */
class TopTooltip {
  static propTypes = {
    content: React.PropTypes.string,
    children: React.PropTypes.node
  }

  render() {
    const tooltip = (<Bs.Tooltip id="">{this.props.content}</Bs.Tooltip>)
    return (
      <Bs.OverlayTrigger
        placement="top"
        overlay={tooltip}>
        {this.props.children}
      </Bs.OverlayTrigger>
    )
  }
}

export default TopTooltip



// WEBPACK FOOTER //
// ./modules/shared/components/topTooltip.js